let $ = jQuery;
let breakpoints = require('../utilities/breakpoints');
let accessibility = require('../utilities/accessibility');
// Import Greensock and it's plugins.
let CSSPlugin = require('../../node_modules/gsap/src/uncompressed/plugins/CSSPlugin');
let EasePack = require('../../node_modules/gsap/src/uncompressed/easing/EasePack');
let TweenLite = require('../../node_modules/gsap/src/uncompressed/TweenLite');

class LabNav {

  constructor(labNav) {
    this.$body = $('body');

    this.$mainNav = $(".js-main-nav-wrapper");
    this.$labNav = labNav;
    this.$stickyLabNav;

    // Add top padding here, when we remove orig nav.
    this.$pageContent = $("#main .region-content");

    this.init();

    $(window).resize(() => this.handleResize()).trigger('resize');
  }

  init() {
    this.$stickyLabNav = this.$labNav.clone();
    this.$stickyLabNav.attr("id", "menu-collasible-sticky");
    this.$mainNav.append(this.$stickyLabNav);

    // Remove old nav.
    this.$labNav.remove();

    this.setPadding();
    this.bind();
  }

  bind() {
    if (breakpoints.current === "small" || breakpoints.current === "medium") {
      this.$stickyLabNav.off("click.stickyLabNav").on("click.stickyLabNav", () => this.handleClick());
    }
    else {
      this.$stickyLabNav.off("click.stickyLabNav");
    }
  }

  setPadding() {
    let height = this.$stickyLabNav.outerHeight();

    this.$pageContent.css('padding-top', height);
  }

  handleClick() {
    this.$stickyLabNav.toggleClass("menu-collapsible__open");

    if (breakpoints.current === "small" || breakpoints.current === "medium") {
      this.$body.toggleClass("noscroll");
    }
  }

  handleResize() {
    this.bind();
    this.setPadding();
  }
}

module.exports = {
  attach: function(context, settings) {
    let nav = $(".js-lab-nav");

    if (nav.length > 0) {
      let labNav = new LabNav(nav);
    }
  }
}
